import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let order_id = useDataValue({
    context: 'order',
    path: 'id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      order_id,
    },
    pause: !order_id,
  }
}
